import { Dropdown } from 'react-bootstrap';
import styles from '../propertydetails.module.css';
import { Archive, Edit, MoreVertical, Trash2 } from 'react-feather';
import { useAuth0 } from '@auth0/auth0-react';

const PropertyCard = ({ data, setEditFormOpen, setArchiveModalOpen, setDeleteModalOpen }) => {
    const { user, isAuthenticated } = useAuth0();

    return (<div className={`${styles.SMProCusSmallDiv}`}>
        <div className={`${styles.CardSmall}`}>
            <div className={`${styles.SMProCardHead}`}>
                <div className={`${styles.SMProPicMain}`}>
                    <img src={data?.new_image !== "" ? data?.new_image : "/static/img/whimage.jpg"} className={`${styles.ProfileIMG}`} alt="" />
                </div>
                <h5>{data?.name}</h5>
                {isAuthenticated && (user["https://propertydek.com/permissions"].indexOf("property:update") > -1 || user["https://propertydek.com/permissions"].indexOf("property:delete") > -1) && <Dropdown className={`${styles.ProEditSec}`}>
                    <Dropdown.Toggle className={`${styles.EditActionsBU} ProsDrBU`} id="dropdown-basic">
                        <MoreVertical />
                    </Dropdown.Toggle>

                    <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("property:update") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => setEditFormOpen(true)}><Edit />Edit</Dropdown.Item>}
                        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("property:update") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => setArchiveModalOpen(true)}><Archive />{data?.is_archived === 1 ? "Unarchive" : "Archive"}</Dropdown.Item>}
                        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("property:delete") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => setDeleteModalOpen(true)}><Trash2 />Delete</Dropdown.Item>}
                    </Dropdown.Menu>
                </Dropdown>}
            </div>
            <div className={`${styles.SMProCardDe}`}>
                <ul>
                    <li>
                        <span className={`${styles.SMProDETag}`}>Owner:</span>
                        <span className={`${styles.SMProDE}`}>{(data?.owner_name !== '') ? data?.owner_name : '-'}</span>
                    </li>
                    <li>
                        <span className={`${styles.SMProDETag}`}>Property Manager:</span>
                        <span className={`${styles.SMProDE}`}>{data?.property_manager}</span>
                    </li>
                    <li>
                        <span className={`${styles.SMProDETag}`}>Authorized Agent:</span>
                        <span className={`${styles.SMProDE}`}>{data?.landlord_agent}</span>
                    </li>
                    <li>
                        <span className={`${styles.SMProDETag}`}>Email:</span>
                        <span className={`${styles.SMProDE}`}>{data?.email}</span>
                    </li>
                    <li>
                        <span className={`${styles.SMProDETag}`}>Phone:</span>
                        <span className={`${styles.SMProDE}`}>{data?.phone}</span>
                    </li>
                    <li>
                        <span className={`${styles.SMProDETag}`}>Address:</span>
                        <span className={`${styles.SMProDE}`}>{data?.fulladdress}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>);
}

export default PropertyCard;